import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialUIModule } from '@app/shared/modules/material-ui/material-ui.module';
import { SharedPipesModule } from '@core/pipes/shared-pipes.module';
import { DxDataGridModule } from 'devextreme-angular';
import { NgxMaskModule } from 'ngx-mask';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxfUploaderModule } from 'ngxf-uploader';
import { GridListComponent } from './grid-list.component';

@NgModule({
  declarations: [GridListComponent],
  imports: [
    CommonModule,
    NgxPaginationModule,
    DxDataGridModule,
    MaterialUIModule,
    SharedPipesModule,
    FormsModule,
    ReactiveFormsModule,
    NgxfUploaderModule,
    NgxMaskModule.forRoot()
  ],
})
export class GridListModule {}
